<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]" class="data-grid__select-cell">
    <b-form-select
      v-model="value"
      :options="selectOptions"
      @change="changed"
      :disabled="controlInfo.readonly"
    />
  </div>
  <div v-else>
    <span>
      <b-badge v-if="value" pill variant="primary">{{ value }}</b-badge>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'isRequired',
    'controlInfo',
  ],
  data() {
    return {
      value: this.cellVal,
    }
  },
  watch: {
    cellVal() {
      this.value = this.cellVal
    },
  },
  computed: {
    ...mapState(['dgRowInEditMode', 'currentDash', 'dataGrid_options']),
    selectOptions() {
      const options = []
      const controlOptions = this.$getDGFBControl(
        this.dataGrid_options[this.gridId].rowEditorFieldsForm,
        this.cellKey
      )

      if (!controlOptions) return options

      const dataOptions = controlOptions.dataOptions

      if (!dataOptions) return options

      for (let option of dataOptions) {
        options.push({ text: option.text, value: option.id })
      }

      return options
    },
    selectedVal() {
      const val = _.find(this.selectOptions, { value: this.cellVal })

      if (val) return val.text
      return null
    },
  },
  methods: {
    changed(value) {
      if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value: value || null,
        }

        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = value
      }
    },
  },
  beforeDestroy() {
    this.value = null
  },
}
</script>

<style lang="scss">
.data-grid__select-cell {
  min-width: 200px;
}
</style>
